 <footer class="site-footer">
            <div class="site-footer__upper">
                <div *ngIf="config.partner != 13" class="container">
                    <div class="row">
                        <div class="col-lg-2">
                            <div class="footer-widget">
                                <a href="/" class="footer-widget__logo"><img src="{{config.logo}}"
                                        width="132" alt="{{config.skinName}}" /></a>

                            </div><!-- /.footer-widget -->
                        </div><!-- /.col-lg-5 -->
                        <div class="col-lg-3">
                            <div class="footer-widget__links-item">
                                <a class="" translate>Monetiza el trafico de tu sitio web a traves de nuestro programa de Afiliados y empieza a multiplicar tu emocion con esta gran oportunidad.</a>

                            </div><!-- /.footer-widget -->
                        </div>
                        <div class="col-lg-3">
                            <div class="footer-widget">
                                <ul class="footer-widget__links">
                                    <li *ngFor="let item of footerMenu" class="footer-widget__links-item"><a (click)="scrollToLink(item.href)">{{item.title}}</a></li>
                                </ul><!-- /.footer-widget__links -->

                            </div><!-- /.footer-widget -->
                        </div><!-- /.col-lg-4 -->
                        <div class="col-lg-4">
                            <div class="site-footer__social">
                                <a href="{{item.href}}" target="_blank" *ngFor="let item of socialMenu"><i class="{{item.icon}}"></i></a>
                            </div>
                        </div><!-- /.site-footer__social -->
                    </div><!-- /.row -->
                </div><!-- /.container -->
                <div *ngIf="config.partner == 13">
                    <div class="footer-social-media">
                        <div class="social-media-logo">
                            <img src="https://images.virtualsoft.tech/m/msjT1672695625.png" alt="" width="250">
                        </div>
                        <div class="container-social-media">
                            <div class="site-footer__social social-media-v2">
                                <a href="{{item.href}}" target="_blank" *ngFor="let item of socialMenu"><i class="{{item.icon}}"></i></a>
                            </div>
                            <div class="title-social-media">
                                <p translate>LA CASA DE APUESTAS DE LOS MEXICANOS</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div><!-- /.site-footer__upper -->
            <div class="site-footer__bottom">
                <div class="col-lg-6 col-md-12 mx-auto">
                    <div class="container">

                    <p class="site-footer__copy-text" [innerHTML]="config.footer.copyright"></p><!-- /.site-footer__copy-text -->
                </div><!-- /.container -->
</div>

            </div><!-- /.site-footer__bottom -->
        </footer><!-- /.site-footer -->
